import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "16 6 12 2 8 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "2", y2: "15", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Share";
const Share = memo(themed(Icon));
export {
  Share
};
//# sourceMappingURL=share.js.map
